import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ConsultaDatosGeneralesRest_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ConsultaDatosGeneralesRest",
    rutaEndPoint: "/EnterpriseServices/Sel/ConsultaDatosGeneralesRest",
    sistemaOrigen: "SEL",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

//ENTRADA

export interface ConsultaDatosGeneralesRest_Entrada {
  CuentaSKY: string;
}

export function builtConsultaDatosGeneralesRest_Entrada(p_CuentaSKY: string) {
  var retorno: ConsultaDatosGeneralesRest_Entrada = {
    CuentaSKY: p_CuentaSKY,
  };

  return retorno;
}

//SALIDA
export interface ConsultaDatosGeneralesRest_Salida {
  respuesta: string;
  respuestadesc: string;
  RowId: string;
  RowIdContacto: string;
  BillingCode: string;
  CuentaSKY: string;
  StatusCuenta: string;
  Organizacion: string;
  CurrencyCode: string;
  NombreSuscriptor: string;
  MarketClass: string;
  MarketType: string;
  OrganizationType: string;
  PromocionActivacion: string;
  Paquete: string;
  StatusRecarga: string;
  Pais: string;
  DiferenciaHoraria: string;
  BanderaNoOPPV: string;
  BanderaNoIPPV: string;
  BanderaHD: string;
  SKY_MODEM_INTERNET: string;
  SKY_PAQUETE_INTERNET: string;
  NO_TC: string;
  OTTUser: string;
  AccountCountryCode: string;
  NUM_RECARGA_VETV: string;
  RazonSocial: string;
  RFC: string;
}

export type ConsultaDatosGeneralesRest_Respuesta = EncabezadoRespuestaInterna &
  ConsultaDatosGeneralesRest_Salida;
